export default __webpack_public_path__ + "static/media/part_2_bt_3.c18ceeed.png";